<template><div><div v-if="!started" class="chat-start"><p>Your assistant can read this account and help with your requests.</p><button type="button" @click="restart">Start conversation</button></div><p v-if="error" role="alert">{{ error }} <button type="button" @click="restart">Reload chat</button></p><iframe v-show="started" ref="frame" loading="eager" :title="title" :src="frameUrl" class="onboarding-chat-frame" @load="configure" /></div></template>
<script>
export default {
  props: { title: { type: String, default: 'Setup assistant chat' }, target: { required: true }, endpoint: { type: String, required: true }, domainKey: { type: String, required: true } },
  data: () => ({ error: '', started: false, frameUrl: 'about:blank', ready: false, timer: null, attempts: 0 }),
  mounted () { window.addEventListener('message', this.receive) },
  beforeDestroy () { window.removeEventListener('message', this.receive); clearTimeout(this.timer) },
  methods: {
    restart () {
      clearTimeout(this.timer); this.started = true; this.ready = false; this.error = ''; this.attempts++
      this.frameUrl = '/onboarding-chat.html?load=' + Date.now()
      this.timer = setTimeout(() => {
        if (this.ready) return
        if (this.attempts < 2) this.restart()
        else this.error = 'The chat did not load. Please reload it.'
      }, 8000)
    },
    configure () {
      const frame = this.$refs.frame
      if (!frame || !frame.contentWindow) return
      frame.contentWindow.postMessage({ type: 'lsa-chatkit.configure', target: this.target, endpoint: this.endpoint,
        domainKey: this.domainKey, title: this.title, token: this.$store.state.auth.jwt }, window.location.origin)
    },
    receive (event) {
      if (event.origin !== window.location.origin || !this.$refs.frame || event.source !== this.$refs.frame.contentWindow) return
      const type = event.data && event.data.type
      if (type === 'lsa-chatkit.ready') { this.ready = true; clearTimeout(this.timer); this.configure() }
      if (type === 'lsa-chatkit.started') this.error = ''
      if (type === 'lsa-chatkit.updated') { this.error = ''; this.$emit('updated') }
      if (type === 'lsa-chatkit.error') this.error = 'Chat could not complete the request. Please try again or use the account settings.'
    }
  }
}
</script>
<style scoped>
.chat-start { padding: 32px 16px; text-align: center; background: #f7faf9; border: 1px solid #e2e7ec; border-radius: 8px; }
.chat-start p { color: #6b7280; font-size: 14px; }
.chat-start button { background: #279a7b; color: white; border-radius: 6px; padding: 10px 18px; font-weight: 600; }
.onboarding-chat-frame { display: block; width: 100%; height: 600px; border: 0; background: white; }
</style>
